// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__25uon","consentsList":"PatientConsents_consentsList__1JKdn","consentsListEmpty":"PatientConsents_consentsListEmpty__3oakJ"};